module.exports = __webpack_public_path__ + "static/media/season-mvp-player.3176f2c3.png";